// eslint-disable-next-line react/prop-types
import { useEffect, useState, useRef } from "react";
import * as cmFun from "common/ulti/commonFunction";
import * as CONSTANTS from "common/ulti/constants";
import { __DEV__ } from "../../../common/ulti/constants";
import { useNavigate, useLocation } from "react-router-dom";
import { Pagination } from "antd";
import PropTypes from "prop-types";

function PaginationAntd({ page, pagesize, _size, _total_pages, ...props }) {
  const navigate = useNavigate();
  const location = useLocation();
  // let { page, pagesize, _size, _total_pages } = props;

  const [_page, setPage] = useState(page || CONSTANTS.DEFAULT_PAGE);
  const [_pagesize, setPageSize] = useState(
    pagesize || CONSTANTS.DEFAULT_PAGESIZE,
  );

  useEffect(() => {
    _init();
  }, [page, pagesize]);

  const _init = () => {
    setPage(page || CONSTANTS.DEFAULT_PAGE);
    setPageSize(pagesize || CONSTANTS.DEFAULT_PAGESIZE);
  };

  const handleSr = (p, ps) => {
    let params = [
      ["page", p],
      ["pagesize", ps],
    ];
    cmFun.insMulParams(params, navigate, location);
  };

  const handlePaginationChange = (pg, sz) => {
    if (pg > _total_pages) return;
    if (pg !== _page) {
      setPage(pg);
      handleSr(pg, _pagesize);
    }

    if (sz !== _pagesize) {
      setPage(CONSTANTS.DEFAULT_PAGE);
      setPageSize(sz);
      handleSr(CONSTANTS.DEFAULT_PAGE, sz);
    }
  };

  return (
    <div className="mt-1 mb-1 float-right">
      <Pagination
        {...props}
        showSizeChanger
        current={_page}
        pageSize={_pagesize}
        total={_size}
        onChange={(page, size) => handlePaginationChange(page, size)}
        locale={{ items_per_page: "/ trang" }}
        pageSizeOptions={CONSTANTS.PAGINATION_SIZE.map(item => String(item.value))}

      />
    </div>
  );
}

PaginationAntd.propTypes = {
  page: PropTypes.number,
  pagesize: PropTypes.number,
  _size: PropTypes.number,
  _total_pages: PropTypes.number,
};

export default PaginationAntd;
